import { atom } from "jotai";

export const currentTimeState = atom(0);
